import { groupBy } from 'libraries/lodash'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import url from 'libraries/front-end-core/core/url'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { DEFAULT_FLAVOUR } from 'constants/flavours'
import { DOCUMENTS_CONTENT } from 'constants/controllers'
import { requestAllDocuments, requestDocumentSections } from 'services/DocumentService'
import { requestUserFavourites } from 'services/FavouritesService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import DocumentsTiledMenu from 'components/tiled-menu/DocumentTiledMenu'
import AolTiles from '../qamenu/AolTiles'
import { AOL_CORPORATE } from 'constants/aol/aol'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import selectDeviceType from 'redux/selectors/selectDeviceType'

const groupSectionsByAol = (sections) => {
  return groupBy(sections, 'areaOfLaw')
}

const DocumentsTiles = ({ sections, documents, favourites, documentFavourites, params, searchType, aol, pageId }) => {
  const keyword = useSelector(state => state.documents.keyword)
  const showFavouritesOnly = useSelector(state => state.documents.showFavouritesOnly)
  const { nodes, topLevelSections } = sections
  const grouped = groupSectionsByAol(topLevelSections)
  const aolKeys = Object.keys(grouped)
  const { isMobile } = useSelector(selectDeviceType)

  useEffect(() => {
    if (aol === undefined) {
      return
    }
    scrollTo({ pageId, id: aol, animate: true, useWindowScrollTo: isMobile })
  }, [pageId, aol, isMobile])

  return (
    <div className='layout-width-constraint pt8'>
      {aolKeys.map((aol, index) => (
        <React.Fragment key={aol}>
          <AolTiles aol={aol}>
            <DocumentsTiledMenu
              flavour={DEFAULT_FLAVOUR}
              favourites={favourites}
              documentFavourites={documentFavourites}
              tiledMenu={{ topLevelSections: grouped[aol], nodes }}
              data-help-item='documenttiles'
              category='Documents'
              keyword={keyword}
              aols={[aol]}
              showFavouritesOnly={showFavouritesOnly}
              getUrl={params => url(
                DOCUMENTS_CONTENT,
                { aol: AOL_CORPORATE, ...params }
              )}
              searchType={searchType}
              documents={documents}
            />
          </AolTiles>
          {index < (aolKeys.length - 1) && <hr className='mt7 grey bg-grey' />}
        </React.Fragment>
      ))}
    </div>
  )
}

export default function DocumentsMenu (props) {
  const showAutomatedOnly = useSelector(state => state.documents.showAutomatedOnly)
  const sections = useObservable(
    requestDocumentSections('corporate', true, showAutomatedOnly),
    RESPONSE_PENDING,
    [showAutomatedOnly]
  )
  const documents = useObservable(
    requestAllDocuments(),
    RESPONSE_PENDING
  )
  const favourites = useObservable(
    requestUserFavourites('documents'),
    RESPONSE_PENDING
  )

  return (
    <ResponseConsumer
      responses={[sections, documents]}
      skeleton='aol-tiled-menu'
      content={() => (
        <DocumentsTiles
          sections={sections}
          documents={documents}
          favourites={favourites}
          documentFavourites={Array.isArray(favourites) ? favourites : []}
          {...props}
        />
      )}
    />
  )
}
